interface UserState {
    userId: number | null;
  }
  
  const initialState: UserState = {
    userId: null,
  };
  
  const userReducer = (state: UserState = initialState, action: { type: string; payload: number | null }) => {
    switch (action.type) {
      case 'SET_USER':
        return {
          ...state,
          userId: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default userReducer;